import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Jika lokasi/rute berubah, gulir ke atas
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, [location.pathname]); // Gunakan location.pathname sebagai dependensi

  return <>{children}</>;
}

export default ScrollToTop;
